// Story 8.7 (ADO-2016) — Toast. Figma "Toast - Item Added to Basket"; the Previous Orders
// re-add instances are 5943:31353 ("Order added to cart") and 5943:31545 ("Cart replaced"),
// and the add-to-cart instances are 4002:14600 / 4002:14998 ("Added to cart",
// `Qty {n} · {product}`, Story 7.9, ADO-1141).
//
// A dark pill: the success CheckCircle, a title over supporting text, and the ShoppingCart.
// By default the pill hugs its text and the rows wrap, so text that must stay whole (a re-add
// toast's order total) is never cut off. The `addedToCart` kind (the add-to-cart instances)
// is a fixed 360px pill, narrower only when its host is: the title keeps to one line and the
// description wraps to at most two, each ending in an ellipsis when it runs out of room. The
// full text stays in the DOM for the live region to announce.
//
// PRESENTATIONAL: it neither positions itself nor times itself out. The app-wide `ToastHost`
// (`apps/web/src/toast`) places it, owns the polite live region it is announced through, and
// dismisses it; the camera scanner, an aria-modal dialog, does the same for its own copy
// inside the dialog (`app/Scan/ScanModal.tsx`).
//
// ADO-2262: `copyKey` keys the title and description block on its own and marks it
// `data-part="copy"`, so a host can replace the copy inside a toast that stays on screen (the
// new copy is new content in the live region, so it is announced). Without it the toast draws
// exactly as before.

import { Icon } from '../Icon/Icon';
import styles from './Toast.module.css';

/** Story 7.9 (ADO-1141): which toast this is, where a kind draws differently from the default
 *  hugging pill. `addedToCart` (Figma 4002:14998) is the fixed 360px pill with a one-line
 *  title and a description of at most two lines, each ending in an ellipsis. The kind sets
 *  only the pill's shape: the host places every toast the same way. */
export type ToastKind = 'addedToCart';

export interface ToastProps {
  readonly title: string;
  readonly description: string;
  readonly kind?: ToastKind | undefined;
  /** ADO-2262: keys the copy block alone; a new key replaces the copy, not the toast. */
  readonly copyKey?: string | number | undefined;
}

export function Toast({ title, description, kind, copyKey }: ToastProps) {
  return (
    <div className={kind === 'addedToCart' ? `${styles.toast} ${styles.fixedWidth}` : styles.toast}>
      <Icon name="checkCircleBold" size={20} className={styles.check} />
      <div
        key={copyKey}
        className={styles.text}
        data-part={copyKey === undefined ? undefined : 'copy'}
      >
        <p className={styles.title}>{title}</p>
        <p className={styles.description}>{description}</p>
      </div>
      <Icon name="shoppingCart" size={18} className={styles.cart} />
    </div>
  );
}
